<template>
  <div>
    <v-navigation-drawer
      :value="isOpen"
      absolute
      right
      width="600px"
      style="z-index: 6; position: fixed"
      :height="dialogHeight"
      touchless
      hide-overlay
      stateless
    >
      <v-card elevation="0" class="ma-7" style="background-color: transparent;">
        <v-card-title class="text-h5" v-if="wms_user.id !== ''">{{getTranslated('_edit')}}</v-card-title>
        <v-card-title class="text-h5" v-else>{{getTranslated('_addWmsUser')}}</v-card-title>
        <v-card-text>
          <v-form @submit.prevent="save" v-model="valid" ref="form" style="flex: 1 1 auto">
          <v-text-field v-model="wms_user.wmsusercode" :rules="requiredRule" maxlength="25" :label="getTranslated('_wmsUserCode')"></v-text-field>
          <v-text-field v-model="wms_user.wmsusertwogroup" :rules="requiredRule" maxlength="25" :label="getTranslated('_wmsUserTwoGroup')"></v-text-field>
          <v-text-field v-model="wms_user.wmsusertwolandingform" :rules="requiredRule" maxlength="25" :label="getTranslated('_wmsUserTwoLandingForm')"></v-text-field>
          <v-text-field v-model="wms_user.wmsusertwolastmove" :rules="requiredRule" maxlength="5" :label="getTranslated('_wmsUserTwoLastMove')"></v-text-field>
          <v-text-field v-model="wms_user.wmsusertwoalmacen" :rules="requiredRule" maxlength="5" :label="getTranslated('_wmsUserTwoAlmacen')"></v-text-field>
          <v-text-field v-model="wms_user.wmsusertworesource" :rules="requiredRule" maxlength="25" :label="getTranslated('_wmsUserTwoResource')"></v-text-field>
          <v-select v-model="wms_user.printlocationid" :rules="requiredRule" :label="getTranslated('_wmsPrintLocation')" :items="wmsPrintLocationList" item-value="id" item-text="id" :no-data-text="getTranslated('_selectNoData')"></v-select>
          <v-text-field v-model="wms_user.wmsusertwolibraries" :rules="requiredRule" maxlength="25" :label="getTranslated('_wmsUserTwoLibraries')"></v-text-field>
          <v-checkbox v-model="wms_user.wmsusertwodefaultuser" :label="getTranslated('_wmsUserTwoDefaultUser')"></v-checkbox>
          <v-checkbox v-model="wms_user.wmsusertwodefaultwarehouse" :label="getTranslated('_wmsUserTwoDefaultWarehouse')"></v-checkbox>
          <v-checkbox v-model="wms_user.wmsusertwovoicedefault" :label="getTranslated('_wmsUserTwoVoiceDefault')"></v-checkbox>
          <v-select v-model="wms_user.wmsusertwogroupwarehouseid" :rules="requiredRule" :label="getTranslated('_wmsUserTwoGroupWarehouse')" :items="wmsWarehousesList" item-value="id" item-text="id" :no-data-text="getTranslated('_selectNoData')"></v-select>
          <v-select v-model="wms_user.wms_instanceid" :rules="requiredRule" :label="getTranslated('_wmsInstanceId')" :items="wmsInstanceList" item-value="id" item-text="instanceName" :no-data-text="getTranslated('_selectNoData')"></v-select>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-tooltip top :disabled="valid" transition="slide-y-reverse-transition">
            <template v-slot:activator="{ on }">
              <div v-on="on">
                <v-btn color="primary" text :disabled="!valid" :loading="loading" @click.stop="save">{{getTranslated('_save')}}</v-btn>
              </div>
            </template>
            <span>{{getTranslated('_saveRequiredValuesAlert')}}</span>
          </v-tooltip>
          <v-btn color="primary" text @click.stop="cancel">{{getTranslated('_cancel')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-navigation-drawer>
    <v-overlay :value="isOpen" z-index="5">
    </v-overlay>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { actions } from '../store/types/wms_userTypes.js'
import wmsprintlocationsService from '../services/Wms_PrintLocationsService.js'
import wmsInstancesService from '../services/WmsInstancesService.js'
import wmswarehousesService from '../services/Wms_WarehousesService.js'

export default {
  name: 'Wms_UserEditionDialog',
  props: {
    openDialog: {
      type: Boolean,
      default: false
    },
    translations: Array
  },
  data () {
    return {
      valid: false,
      requiredRule: [v => !!v || this.getTranslated('_required')],
      dialogHeight: window.innerHeight,
      wmsPrintLocationList: [],
      loading: false,
      wmsInstanceList: [],
      wmsWarehousesList: []
    }
  },
  computed: {
    ...mapState({
      wms_user: state => state.wmsusers.wmsuser
    }),
    isOpen: {
      get () {
        return this.openDialog
      },
      set (val) {
        this.$emit('input', val)
      }
    }
  },
  methods: {
    ...mapActions({
      saveWms_User: actions.SAVE_WMS_USER,
      clearWms_User: actions.CLEAR_WMS_USER
    }),
    async save () {
      this.loading = true
      await this.saveWms_User(this.wms_user).then(res => {
        var notification = {
          color:
            res.request.status === 200 || res.request.status === 201
              ? 'green'
              : 'red',
          message:
            res.request.status === 200 || res.request.status === 201
              ? this.getTranslated('_wmsUserSaved')
              : this.getTranslated('_wmsUserSavedError')
        }
        this.loading = false
        this.$emit('saved', notification)
        this.cancel()
      })
    },
    cancel () {
      this.loading = false
      this.isOpen = false
      this.$refs.form.reset()
      this.clearWms_User()
    },
    handleResize (event) {
      this.dialogHeight = window.innerHeight
    },
    getTranslated (key) {
      var translation = this.translations.filter(element => element.key === key)
      if (translation.length > 0) {
        return translation[0].translation
      } else {
        return 'Translation Error: ' + key
      }
    },
    async getPrintingLocationList () {
      var response = await wmsprintlocationsService.get()
      this.wmsPrintLocationList = response.data
    },
    async getWmsInstances () {
      var response = await wmsInstancesService.get()
      this.wmsInstanceList = response.data
    },
    async getWmsWarehouses () {
      var response = await wmswarehousesService.get()
      this.wmsWarehousesList = response.data
    },
    initialize () {
      this.getPrintingLocationList()
      this.getWmsInstances()
      this.getWmsWarehouses()
    }
  },
  created () {
    window.addEventListener('resize', this.handleResize)
    this.initialize()
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.handleResize)
  }
}
</script>
